import React, { FunctionComponent } from 'react';
import {
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelProps
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';

interface Props extends ExpansionPanelProps {
  summary: string;
  defaultExpanded?: boolean;
}

const useStyles = makeStyles({
  root: {
    backgroundColor: '#546c78',
  },
});

const TestCasePanel: FunctionComponent<Props> = ({
  children,
  summary,
  defaultExpanded,
  expanded,
  onChange
}) => {
  const classes = useStyles();

  return (
    <ExpansionPanel
      style={{ overflow: 'hidden' }}
      defaultExpanded={defaultExpanded}
      expanded={expanded}
      onChange={onChange}
    >
      <ExpansionPanelSummary
        className={`flex-pill ${classes.root}`}
        expandIcon={<ExpandMore className="white-text" />}
      >
        <Typography className="white-text">{summary}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className="pb-2">{children}</ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default TestCasePanel;
